import { render, staticRenderFns } from "./ContainersWidget.vue?vue&type=template&id=0df55b32&scoped=true&"
import script from "./ContainersWidget.vue?vue&type=script&lang=js&"
export * from "./ContainersWidget.vue?vue&type=script&lang=js&"
import style0 from "./ContainersWidget.vue?vue&type=style&index=0&id=0df55b32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df55b32",
  null
  
)

export default component.exports